module.exports = __webpack_public_path__ + "img/icon1.78711d36.png";